import { Button, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import GroupsIcon from '@mui/icons-material/Groups';
import { useAuthContext } from '../../auth/hooks/useAuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMeetingState } from '../../../features/meeting/meetingSlice';
import { socket } from '../../../config/SocketApi';
const SelectMeeting = () => {
    const dispatch = useDispatch();
    const { user } = useAuthContext() || JSON.parse(localStorage.getItem("user"));
    const { whiteBoardDimensions } = useSelector((store) => store.screenSharing)
    const theme = useTheme();
    const { t } = useTranslation();
    const [meetingStarted, setMeetingStarted] = useState(false);
    const toggleMeeting = () => {
        socket.emit("meeting-started-end-sharing", {});
        socket.emit("meeting-state", JSON.stringify({ state: !meetingStarted, whiteBoardDimensions }))
        dispatch(toggleMeetingState({ status: !meetingStarted }))
        setMeetingStarted(prev => !prev)


    }
    return (
        <Button onClick={() =>
            toggleMeeting()
        }
            variant="outlined"
            sx={{
                pr: theme.direction === "rtl" ? '0px' : '10px',
                color: theme.palette.secondary.main,
                borderColor: theme.palette.secondary.main,
                display: user?.user_type !== 0 ? 'inline-flex' : 'none'
            }}
            startIcon={<GroupsIcon sx={{ ml: theme.direction === "rtl" ? '10px' : '0px' }} />} >
            {meetingStarted ? t("endMeeting") : t("startMeeting")}
        </Button>
    )
}

export default SelectMeeting